import { useMappedState } from "redux-react-hook";
import * as React from "react";

import { IStore } from "src/core/shared/store/index";

const useTerminology = () => {
  const terminology = useMappedState((store: IStore) => store.global.settings?.terminology);

  const terminologyMemo = React.useMemo(() => {
    return terminology;
  }, [ terminology ]);

  return terminologyMemo;
};

export default useTerminology;
